import ErrorMessage from 'components/common/ErrorMessage';
import React, { useCallback, useState } from 'react';
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { Spinner } from 'reactstrap';
import { profileSelector } from 'slices/profileSlice';
import { changePassword } from 'slices/profileSlice';
import { setError } from 'slices/profileSlice';
import { userSelector } from 'slices/userSlice';

const ChangePassword = () => {
    const [showPassword, setShowPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const { loader, error } = useSelector(profileSelector);

    const dispatch = useDispatch();
    const [formValues, setFormValues] = useState({
        current_password: "",
        password: "",
        password_confirmation: "",
    });

    const togglePasswordVisibility = useCallback(() => {
        setShowPassword(!showPassword);
    }, [showPassword]);

    const toggleNewPasswordVisibility = useCallback(() => {
        setShowNewPassword(!showNewPassword);
    }, [showNewPassword]);

    const toggleConfirmPasswordVisibility = useCallback(() => {
        setShowConfirmPassword(!showConfirmPassword);
    }, [showConfirmPassword]);


    const submitCallback = (status, message) => {
        if (status) {
            toast.success("Updated Successfully")
            // navigate('/admin/schedule', { replace: true });
        }
        else {
            toast.error("Invalid Credentials");
        }
    };

    const handleSubmit = useCallback((e) => {
        e.preventDefault();

        // Validate form
        const { current_password, password, password_confirmation } = formValues
        if (password !== password_confirmation) {
            // Show error message
            dispatch(setError({
                password_confirmation: "Passwords do not match!"
            }))
            return;
        }

        dispatch(setError({}))
        dispatch(changePassword(formValues, submitCallback))
    }, [formValues]);

    const handleChange = useCallback((e) => {
        setFormValues({ ...formValues, [e.target.name]: e.target.value });
    }, [formValues])

    return (
        <>
            <div className="content">
                <div className="row_main_head"><h2 className="main_heading">Change Password</h2></div>

                <div className="container_main mt-4">
                    <div className="link_table">
                        <form className="auth_form formFor_pass" onSubmit={handleSubmit}>

                            <div className="form-group">
                                <label>Old Password</label>
                                <div className="row-input">
                                    <img src="/images/lock.png" alt="lock icon" />
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        required
                                        onChange={handleChange}
                                        autoComplete="off"
                                        placeholder="Enter your password"
                                        value={formValues.current_password}
                                        name='current_password'
                                    />
                                    <img src={showPassword ? "/images/eye-close.png" : "/images/eye.png"} alt="toggle password visibility" onClick={togglePasswordVisibility} style={{ cursor: 'pointer' }} />
                                </div>
                            </div>

                            <div className="form-group">
                                <label>New Password</label>
                                <div className="row-input">
                                    <img src="/images/lock.png" alt="lock icon" />
                                    <input
                                        type={showNewPassword ? "text" : "password"}
                                        required onChange={handleChange}
                                        autoComplete="off"
                                        placeholder="Enter your new password"
                                        value={formValues.password}
                                        name='password'

                                    />
                                    <img src={showNewPassword ? "/images/eye-close.png" : "/images/eye.png"} alt="toggle password visibility" onClick={toggleNewPasswordVisibility} style={{ cursor: 'pointer' }} />
                                </div>
                            </div>

                            <div className="form-group">
                                <label>Confirm Password</label>
                                <div className="row-input">
                                    <img src="/images/lock.png" alt="lock icon" />
                                    <input
                                        type={showConfirmPassword ? "text" : "password"}
                                        required
                                        autoComplete="off"
                                        placeholder="Confirm your password"
                                        onChange={handleChange}
                                        value={formValues.password_confirmation}
                                        name='password_confirmation'

                                    />
                                    <img src={showConfirmPassword ? "/images/eye-close.png" : "/images/eye.png"} alt="toggle password visibility" onClick={toggleConfirmPasswordVisibility} style={{ cursor: 'pointer' }} />


                                </div>
                                {
                                    error && error?.password_confirmation && <ErrorMessage text={error?.password_confirmation} />

                                }
                            </div>



                            {
                                error && error?.current_password && <ErrorMessage text={error?.current_password} />
                            }
                            <button disabled={loader} type="submit" className={`main_button mt-5 ${loader ? "disabled-button" : ""}`}>
                                {loader ? (
                                    <>
                                        <Spinner size="sm">Loading...</Spinner>
                                        <span> Loading</span>
                                    </>
                                ) : (
                                    <span>Change Password</span>
                                )}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ChangePassword;
